
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/modern-slavery-statement",
      function () {
        return require("private-next-pages/policies/modern-slavery-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/modern-slavery-statement"])
      });
    }
  